import { useState } from "react";

import { client } from "@/config/client";
import { useAppNotification } from "@/modules/app-notification";

import { handleImportSuccess, handleImportErrors } from "./importToolXSLX.util";

export const useImport = () => {
  const [loading, setLoading] = useState(false);
  const { notify } = useAppNotification();

  const handleImport = (model, path, operation) => {
    setLoading(true);

    return client[model]
      .imports(operation, path)
      .then(({ data }) => handleImportSuccess(data.data))
      .catch((error) => handleImportErrors(error, notify))
      .finally(() => setLoading(false));
  };

  return { loading, handleImport };
};
